import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { ArrowRightCircle } from "react-bootstrap-icons";
import headerImg from "../images/header-img.svg";

const Banner = () => {
  const [loopIdx, setLoopIdx] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const toRotate = ["webpages", "web applications", "phenomenal portfolios"];
  const [text, setText] = useState("");
  const [delta, setDelta] = useState(250 - Math.random() * 100);
  const period = 1500;

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => {
      clearInterval(ticker);
    };
  }, [text]);

  const tick = () => {
    let i = loopIdx % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting
      ? fullText.substring(0, text.length - 1)
      : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta((prevDelta) => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setDelta(period);
    } else if (isDeleting && updatedText === "") {
      setIsDeleting(false);
      setLoopIdx(loopIdx + 1);
      setDelta(250);
    }
  };

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6} xl={7}>
            <span className="tagline" style={{ display: "none" }}>
              Welcome to my portfolio
            </span>
            <h1>
              {"Hi! My name is Paweł Nietupski"} <br /> {"I create "}
              <span className="wrap">{text}</span>
            </h1>
            <p>
              For the last few years I've been working as a freelance developer.
              I've done remote work for agencies and individual clients to
              create websites and applications for both business and consumer
              use. <br />
              <br /> I'm naturally curious, and perpetually working on improving
              my skills one project at a time.
            </p>
            <a href="#contact" style={{ textDecoration: "none" }}>
              <button id="skills">
                Let's connect! <ArrowRightCircle size={25} />
              </button>
            </a>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <img src={headerImg} alt="Banner image" />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Banner;
